module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "OverlayMenu-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu.isVisible),
      expression: "menu.isVisible"
    }],
    staticClass: "OverlayMenu"
  }, [_c('div', {
    staticClass: "OverlayMenu-items"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "OverlayMenu-item",
      attrs: {
        "to": item.path
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem.apply(null, arguments)
        }
      }
    }, [_c('container', [_vm._v("\n\n            " + _vm._s(item.title) + "\n\n          ")])], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "OverlayMenu-footer"
  }, [_c('container', [_c('p', {
    staticClass: "t-caps-md c-grey-xxlt"
  }, [_vm._v("\n            Contact Benj+Sara\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "t-text-sm c-grey-lt",
    attrs: {
      "href": ("mailto:" + (_vm.global.site.email.value))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.global.site.email.label) + "\n          ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35273540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverlayMenu.vue
// module id = 755
// module chunks = 1474